export const formatNumber = (amount: number | string): string => {
  return new Intl.NumberFormat('en-US').format(amount);
};
